"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _dataparcels = _interopRequireDefault(require("dataparcels"));

var _callback = _interopRequireDefault(require("use-debounce/lib/callback"));

var _ApplyBeforeChange = _interopRequireDefault(require("./util/ApplyBeforeChange"));

// $FlowFixMe - useState is a named export of react
var _default = function _default(params) {
  var getValue = typeof params.value === "function" ? params.value : function () {
    return params.value;
  }; // takes a parcel and chains the beforeChange functions off of it
  // placing them each inside .modifyUp()s
  // so that all changes made to the returned parcel
  // go up through all of beforeChange's functions

  var applyBeforeChange = (0, _ApplyBeforeChange.default)(params.beforeChange); //
  // debounce
  //

  var _useDebouncedCallback = (0, _callback.default)(params.onChange, params.debounce),
      _useDebouncedCallback2 = (0, _slicedToArray2.default)(_useDebouncedCallback, 1),
      debouncedOnChange = _useDebouncedCallback2[0]; // takes a parcel and sets the current params.value as its value
  // (params.value is first passed through beforeChange),
  // then passes the resulting parcel through beforeChange
  // so that all changes made to the returned parcel
  // go up through all of beforeChange's functions


  var updateParcelValue = function updateParcelValue(parcel) {
    var _parcel$_changeAndRet = parcel._changeAndReturn(function (parcel) {
      return applyBeforeChange(parcel).set(getValue());
    }),
        _parcel$_changeAndRet2 = (0, _slicedToArray2.default)(_parcel$_changeAndRet, 1),
        changedParcel = _parcel$_changeAndRet2[0];

    return applyBeforeChange(changedParcel);
  };

  var _useState = (0, _react.useState)(function () {
    return updateParcelValue(new _dataparcels.default({
      handleChange: function handleChange(parcel, changeRequest) {
        setParcel(applyBeforeChange(parcel));

        if (params.onChange) {
          var fn = params.debounce ? debouncedOnChange : params.onChange;
          fn(parcel, changeRequest);
        }
      }
    }));
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      parcel = _useState2[0],
      setParcel = _useState2[1];

  var _useState3 = (0, _react.useState)(function () {
    return parcel.value;
  }),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      prevValue = _useState4[0],
      setPrevValue = _useState4[1];

  if (params.updateValue) {
    var value = getValue();

    if (!Object.is(value, prevValue)) {
      setPrevValue(value);
      setParcel(updateParcelValue(parcel));
    }
  }

  return [parcel];
};

exports.default = _default;